<template>
	<div class="sp-template">
		<div class="h-title">司机管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item>
						<el-input v-model="conditions.search" placeholder="请输入司机姓名" clearable @change="searchDriver()"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button  v-if="in_configs(70504)" type="primary" @click="searchDriver()">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(70501)" size="small" @click="dialogFormVisible = true">添加司机</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" :data="driverData" stripe border style="width: 100%">
				<el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="phone" label="联系方式"></el-table-column>
				<el-table-column prop="cardId" label="身份证"></el-table-column>
				<el-table-column prop="wechatId" label="微信号"></el-table-column>
				<el-table-column prop="status" :formatter="judge" label="状态"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button v-if="in_configs(70502)" type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<!-- <i v-if="in_configs(70503)" class="el-icon-delete" @click="deleteDriver(scope.$index, driverData)"></i> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background 
				@size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage" 
        :page-sizes="[10, 20, 50, 100]" 
        :page-size="pageSize" 
        layout="total, sizes, prev, pager, next, jumper" 
        :total = "parseInt(total)">
			</el-pagination>
			<!-- 弹窗 -->
			<el-dialog title="司机详情" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="resetForm('driverForm')" width="500px" class="fullwidth-form__dialog">
				<el-form :model="driverForm" status-icon :rules="rule" ref="driverForm" size="small" label-width="80px">
					<el-form-item label="联系人"  prop="name">
						<el-input v-model="driverForm.name" auto-complete="off" placeholder="联系人"></el-input>
					</el-form-item>
					<el-form-item label="手机号"  prop="phone">
						<el-input v-model="driverForm.phone" auto-complete="off" placeholder="手机号"></el-input>
					</el-form-item>
					<el-form-item label="身份证"  prop="cardId">
						<el-input v-model="driverForm.cardId" auto-complete="off" placeholder="身份证"></el-input>
					</el-form-item>
					<el-form-item label="微信号"  prop="wechatId">
						<el-input v-model="driverForm.wechatId" auto-complete="off" placeholder="微信号"></el-input>
					</el-form-item>
					<el-form-item label="状态" >
						<el-radio v-model="driverForm.status" label="1">启用</el-radio>
						<el-radio v-model="driverForm.status" label="0">停用</el-radio>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="resetForm('driverForm')">取 消</el-button>
					<el-button size="small" type="primary" @click="createDriver('driverForm')">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
  data() {
		var validName = (rule, value, callback) => {
			this.$request1({
				method: 'POST',
				url: '/system/driver/check',
				params: {
					id: this.driverForm.id,
					name: value,
					phone: "",
					cardId: "",
					wechatId: ""
				}
			}).then(response => {
				if(response.data.message == "Duplicate name"){
					callback(new Error('司机姓名已存在！'));
				} else{
					callback();
				}
			}).catch(error => {
				console.log(error);
			})
		}
		var validPhone = (rule, value, callback) => {
			setTimeout(() => {
				var pattern = /^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/;
				if(!pattern.test(value)){
					callback(new Error('请输入正确的手机号！'));
				}else{
					callback();
				}
			}, 1000);
			this.$request1({
				method: 'POST',
				url: '/system/driver/check',
				params: {
					id: this.driverForm.id,
					name: "",
					phone: value,
					cardId: "",
					wechatId: ""
				}
			}).then(response => {
				if(response.data.message == "Duplicate phone"){
					callback(new Error('手机号已存在！'));
				} else{
					callback();
				}
			}).catch(error => {
				console.log(error);
			})
		};
		var validIDCard = (rule, value, callback) => {
				setTimeout(() => {
					var pattern = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
					if(!pattern.test(value)){
						callback(new Error('请输入正确的身份证号码！'));
					} else{
						callback();
					}
				}, 1000);
				this.$request1({
					method: 'POST',
					url: '/system/driver/check',
					params: {
						id: this.driverForm.id,
						name: "",
						phone: "",
						cardId: value,
						wechatId: ""
					}
				}).then(response => {
					if(response.data.message == "Duplicate card id"){
						callback(new Error('身份证号已存在！'));
					} else{
						callback();
					}
				}).catch(error => {
					console.log(error);
				})
		};
		var validWechatId = (rule,value, callback) => {
			if(value){
				this.$request1({
					method: 'POST',
					url: '/system/driver/check',
					params: {
						id: this.driverForm.id,
						name: "",
						phone: "",
						cardId: "",
						wechatId: value
					}
				}).then(response => {
					if(response.data.message == "Duplicate wechat id"){
						callback(new Error('微信号已存在！'));
					} else{
						callback();
					}
				}).catch(error => {
					console.log(error);
				})
			}
		}
    return {
      conditions: {
        search: ""
      },
      driverData: [],
      driverForm: {
        id: "",
        name: "",
				phone: "",
				cardId: "",
				wechatId: "",
				status: "1"
      },
      currentPage: 1, // 当前是第几页
      pageSize: 10, // 每页显示条目个数
      total: 0, // 总条目数
      dialogFormVisible: false,
			duplicatePhone: false,
			duplicateIDCard: false,
      formLabelWidth: "120px",
			rule:{
				name:[
					{validator: validName, trigger: 'blur'},
					{required: true, message: '请输入司机姓名', trigger: 'blur'}
				],
				phone:[
					// {validator: validPhone, trigger: 'blur'},
					{required: true, message: '请输入手机号', trigger: 'blur'}				
				],
				cardId:[
					{required: true, message: '请输入身份证号', trigger: 'blur'},
					{validator: validIDCard, trigger: 'blur'}
				],
				wechatId:[
					{required: true, message: '请输入微信号', trigger: 'blur'},
					{validator: validWechatId, trigger: 'blur'}
				]
			}
    };
  },
  components: {},
  created() {
		setTimeout(() => {
			this.initDriver(this.conditions.search, this.currentPage, this.pageSize)
			this.loading = false;
		}, 1000);
	},
  computed: {
		//权限
		configs() {
			let conf = JSON.parse(sessionStorage.configs),
				arr = [];
			conf.forEach((d, i) => {
				arr.push(d.name)
			})
			return arr;
		}
	},
  methods: {
		judge(data) {
      return data.status == "1" ? "启用" : "停用";
    },
		// 初始化查询方法
		initDriver(name, currentPage, pageSize){
			if (name === '') {name = null}
			this.$request1({
				method: 'GET',
				url: '/system/driver/query',
				params: {
          name: name,
          currentPage: currentPage,
          pageSize: pageSize
        }
			}).then(response => {
				if(response.data.success) {
					if(response.data.data && response.data.data.length > 0) {
						this.driverData = response.data.data;
						this.total = response.data.total;
					} else{
						this.driverData = [];
					}
				} else{
					this.$message.error(response.data.message)
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		// 添加司机
		createDriver(formName){
			this.$refs[formName].validate((valid) => {
				if(valid){
					this.$request1({
						method: 'POST',
						url: '/system/driver/create',
						data: this.driverForm
					}).then(response =>{
						if(response.data.success){
							this.$message.success('成功！')
							this.initDriver(this.conditions.search, this.currentPage, this.pageSize);		
							this.$refs[formName].resetFields();				
							this.emptyForm();
							this.dialogFormVisible = false;
						} else{
							this.$message.error(response.data.message)
						}
					}).catch(error =>{
						console.log(error)
					})
				} else{
					return false;
				}
			})
		},
    //搜索
    searchDriver() {
      let name = this.conditions.search.trim();
			this.initDriver(name, this.currentPage, this.pageSize);
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
			this.driverForm.id = row.id;
			this.driverForm.name = row.name;
			this.driverForm.phone = row.phone;
			this.driverForm.cardId = row.cardId;
			this.driverForm.wechatId = row.wechatId;
			this.driverForm.status = row.status.toString();
    },
    //删除
    deleteDriver(index, rows) {
			this.$confirm("您确定要删除这条司机信息吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
				let id = rows[index].id;
				this.$request1({
					method: 'GET',
					url: '/system/driver/delete',
					params:{id: id}
				}).then((response) => {
					rows.splice(index, 1);
					this.initDriver(this.conditions.search, this.currentPage, this.pageSize);
					this.$message({
						message: "删除成功",
						type: "success",
						center: true,
						duration: 1500
					});
				}).catch(error => {
					console.log(error);
				});
			})
			.catch(() => {
				this.$message({
					type: "info",
					message: "已取消删除"
				});
			});
    },
		//清空表单
		emptyForm(){
			this.driverForm.id = "";
			this.driverForm.name = "";
			this.driverForm.phone = "";
			this.driverForm.cardId = "";
			this.driverForm.wechatId = "";
			this.driverForm.status = "1";
			this.dialogFormVisible = false;
		},
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.initDriver(this.conditions.search, this.currentPage, val);
    },
    handleCurrentChange(val) {
      this.initDriver(this.conditions.search, val, this.pageSize);
    },
		resetForm(formName){
			this.$refs[formName].clearValidate();
			this.emptyForm();
		},
		rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/driver.vue